import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Button, Input, Label } from 'reactstrap';

class CoWorker extends Component {
  constructor (props) {
    super(props);
    this.state = { q1: 1, q2: 1, q3: 1, q4: 1, q5: 1, q6: 1, q7: 1, q8: 1 };
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  render () {
    const { worker_first_name: first, worker_last_name: last, handleSubmit, t } = this.props;
    const putUser = string => string.replace(/_worker_/img, `${first} ${last}`);

    return (
      <form className='form-group mt-3' onSubmit={handleSubmit}>
        <div className='form-group'>
          <label>{putUser(t('ref:coWorker.q1'))}</label>
          <div className='col col-12'>
            <div className='col'>
              <Label check>
                <Input type='radio' required name='q1' value='1'
                  onChange={this.handleChange} />{' '}
                {t('common:yes')}
              </Label>
            </div>
            <div className='col'>
              <Label check>
                <Input type='radio' required name='q1' value='0'
                  onChange={this.handleChange} />{' '}
                {t('common:no')}
              </Label>
            </div>
          </div>
        </div>
        <div className='form-group'>
          <label>{putUser(t('ref:coWorker.q2'))}</label>
          <div className='col col-12'>
            <div className='col'>
              <Label check>
                <Input type='radio' required name='q2' value='1'
                  onChange={this.handleChange} />{' '}
                {t('common:yes')}
              </Label>
            </div>
            <div className='col'>
              <Label check>
                <Input type='radio' required name='q2' value='0'
                  onChange={this.handleChange} />{' '}
                {t('common:no')}
              </Label>
            </div>
          </div>
        </div>
        <div className='form-group'>
          <label>{putUser(t('ref:coWorker.q3'))}</label>
          <div className='col col-12'>
            <div className='col'>
              <Label check>
                <Input type='radio' required name='q3' value='1'
                  onChange={this.handleChange} />{' '}
                {t('common:yes')}
              </Label>
            </div>
            <div className='col'>
              <Label check>
                <Input type='radio' required name='q3' value='0'
                  onChange={this.handleChange} />{' '}
                {t('common:no')}
              </Label>
            </div>
          </div>
        </div>
        <div className='form-group'>
          <label>{putUser(t('ref:coWorker.q4'))}</label>
          <div className='row col col-6'>
            <select required name='q4' className='custom-select'
              onChange={this.handleChange}>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
            </select>
          </div>
        </div>
        <div className='form-group'>
          <label>{putUser(t('ref:coWorker.q5'))}</label>
          <div className='row col col-6'>
            <select required name='q5' className='custom-select'
              onChange={this.handleChange}>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
            </select>
          </div>
        </div>
        <div className='form-group'>
          <label>{putUser(t('ref:coWorker.q6'))}</label>
          <div className='row col col-6'>
            <select required name='q6' className='custom-select'
              onChange={this.handleChange}>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
            </select>
          </div>
        </div>
        <div className='form-group'>
          <label>{putUser(t('ref:coWorker.q7'))}</label>
          <div className='row col col-6'>
            <select required name='q7' className='custom-select'
              onChange={this.handleChange}>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
            </select>
          </div>
        </div>
        <div className='form-group'>
          <label>{putUser(t('ref:coWorker.q8'))}</label>
          <div className='row col col-6'>
            <select required name='q8' className='custom-select'
              onChange={this.handleChange}>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
            </select>
          </div>
        </div>
        <div className='d-flex align-items-center justify-content-between'>
          <Button type='submit' color='primary'>{t('common:send')}</Button>
        </div>
      </form>
    );
  }
}

export default translate()(CoWorker);



// WEBPACK FOOTER //
// ./src/components/app/references/CoWorker.js